module.exports = __webpack_public_path__ + "img/SMBC.8dc3bc6f.png";